<div class="info" *ngIf="property">
  <header>
    <div *ngIf="!property.price.includes('$')" class="price">
      {{ property.price | currency: 'USD' : 'symbol' : '1.0-2' }}
    </div>
    <div *ngIf="property.price.includes('$')" class="price">
      {{ property.price.replace(' ', '') }}
    </div>
    <app-property-list-status
      [status]="property.status"
    ></app-property-list-status>
  </header>

  <ng-container *ngIf="!isLoggedIn">
    <div class="address">
      {{ property.city || '' | stringTransform: 'capitalizeEachWord' }},
      <span class="uppercase">{{ property.state }}</span> {{ property.zip }}
    </div>
    <div class="unlock-info">
      <app-shared-icon name="lock-gray" [size]="15"></app-shared-icon>
      <span>Unlock all property details by signing in</span>
    </div>
  </ng-container>

  <ng-container *ngIf="isLoggedIn">
    <div class="details">
      <span>{{ Number(property.bedrooms) || '-' }} Beds</span>
      <span>{{ Number(property.bathrooms) || '-' }} Baths</span>
      <span>{{ Number(property.squareFoot) || '-' }} Sqft</span>
    </div>

    <div class="address">
      {{ property.houseNumber }}
      {{ property.street || '' | stringTransform: 'capitalizeEachWord' }},
      {{ property.city || '' | stringTransform: 'capitalizeEachWord' }},
      <span class="uppercase">{{ property.state }}</span> {{ property.zip }}
    </div>

    <div class="offered-by">
      Offered by:
      <span *ngIf="!property.offMarket">{{ property.organization.name }}</span>
      <span *ngIf="property.offMarket">{{
        property.offMarket.companyName
      }}</span>
    </div>
  </ng-container>
</div>
